export default __webpack_public_path__ + "static/media/instagram.f8191acd.jpg";